import React from 'react';

type FormFieldProps = {
  label?: string;
  htmlFor?: string;
  children: React.ReactNode;
};

// grow-ui's Form.Field: the field's vertical spacing with a plain label above
// the control. FieldLabel in components/UiKit floats instead, which these
// forms never did.
const FormField = ({ label, htmlFor, children }: FormFieldProps) => (
  <div className="my-4 w-full">
    {label && (
      <label htmlFor={htmlFor} className="block text-gray-600 font-medium">
        {label}
      </label>
    )}
    {children}
  </div>
);

export default FormField;
